"use client";

import { renderDiscoverPageRoute } from "@faire/retailer/views/discover/Route";

export const RenderDiscoverPageRoute = () => {
  return renderDiscoverPageRoute();
};
